import React from "react";
import { makeStyles, createStyles } from "@material-ui/core";
import { ITheme } from "../../Layout/themes";
import smallImage from "../../../../../public/images/iphoneSE.jpg";
import bigImage from "../../../../../public/images/iphoneX.jpg";

const useStyles = makeStyles(({ palette, breakpoints }: ITheme) => {
  return createStyles({
    bottomPanel: {
      backgroundColor: "#20a8ae",
      width: "100%",
      height: "316px",
      [breakpoints.down(321)]: {
        height: "192px"
      }
    },
    AppsImageBig: {
      width: "100%",
      height: "316px",
      [breakpoints.down(321)]: {
        display: "none"
      },
      [breakpoints.up(321)]: {
        display: "show"
      }
    },
    AppsImageSmall: {
      width: "100%",
      height: "192px",
      [breakpoints.down(321)]: {
        display: "show"
      },
      [breakpoints.up(321)]: {
        display: "none"
      }
    }
  });
});

export const MobileAppsRedirectImage = () => {
  const classes = useStyles({});
  return (
    <div className={classes.bottomPanel}>
      <img className={classes.AppsImageBig} src={bigImage} />
      <img className={classes.AppsImageSmall} src={smallImage} />
    </div>
  );
};
